// Lógica de wishlist de las tarjetas de producto.
// Antes estaba inline en snippets/card-product.liquid y se ejecutaba una vez por tarjeta.
// Las traducciones se definen en window.cardProductStrings (layout/theme.liquid).
(function () {
  // Variables globales para wishlist
  window.wishlistProductIds = window.wishlistProductIds || new Set();
  window.wishlistItems = window.wishlistItems || [];
  window.wishlistLid = window.wishlistLid || null;
  window.wishlistInitialized = window.wishlistInitialized || false;

  // Función para añadir/eliminar de favoritos
  window.addToFavorites = function (button) {
    const empi = button.dataset.empi;

    // Verificar el estado real del botón basado en su texto, clases y dataset
    const buttonText = button.textContent.trim();
    const hasInWishlistClass = button.classList.contains('is-in-wishlist');
    const hasInWishlistDataset = button.dataset.inWishlist === 'true';
    const hasEliminarText = buttonText.includes('Eliminar') || buttonText.includes('🗑');

    // Determinar si está en wishlist basándose en múltiples criterios
    const isInWishlist = hasInWishlistClass || hasInWishlistDataset || hasEliminarText;

    if (isInWishlist) {
      // Eliminar directamente de favoritos sin abrir drawer

      // Configurar los datos necesarios para removeFromWishlist
      const { productUrl, epi, empi, du, dt, iu } = button.dataset;

      // Usar du que ya tiene la URL completa, o convertir productUrl si du no está disponible
      let fullProductUrl = du || productUrl;
      if (fullProductUrl && !fullProductUrl.startsWith('http')) {
        fullProductUrl = window.location.origin + fullProductUrl;
      }

      // Crear un elemento temporal con los datos necesarios para removeFromWishlist
      const tempButton = document.createElement('button');
      tempButton.dataset.productId = empi; // Usar empi como productId
      tempButton.dataset.productUrl = fullProductUrl; // Usar URL completa
      tempButton.dataset.productEmpi = empi;
      tempButton.dataset.productEpi = epi;

      // Obtener el listId correcto
      let listId = '';

      // Buscar el item específico en wishlistItems para obtener su lid
      if (window.wishlistItems && window.wishlistItems.length > 0) {
        const item = window.wishlistItems.find((item) => item.empi.toString() === empi);
        if (item && item.lid) {
          listId = item.lid;
        } else {
          // Fallback al wishlistLid global
          listId = window.wishlistLid || '';
        }
      } else {
        // Si no hay wishlistItems, usar el wishlistLid global
        listId = window.wishlistLid || '';
      }

      tempButton.dataset.listId = listId;

      // Modificar la función removeFromWishlist para eliminar todas las variantes del producto
      const originalRemoveFromWishlist = window.removeFromWishlist;
      window.removeFromWishlist = function (button) {
        const productEmpi = button.dataset.productEmpi;
        const listId = button.dataset.listId;

        // Buscar todas las variantes del producto en wishlistItems
        if (window.wishlistItems && window.wishlistItems.length > 0) {
          const productVariants = window.wishlistItems.filter((item) => item.empi.toString() === productEmpi);

          if (productVariants.length > 0) {
            // Crear array con todas las variantes del producto
            const productsToRemove = productVariants.map((item) => ({
              du: item.du,
              empi: parseInt(item.empi),
              epi: parseInt(item.epi),
            }));

            // Llamar a Swym para eliminar todas las variantes
            if (window._swat && typeof window._swat.removeProductsFromList === 'function') {
              window._swat.removeProductsFromList(
                listId,
                productsToRemove,
                function (success) {
                  // Actualizar las variables globales
                  if (window.wishlistProductIds) {
                    window.wishlistProductIds.delete(productEmpi);
                  }
                  if (window.wishlistItems) {
                    window.wishlistItems = window.wishlistItems.filter((item) => item.empi.toString() !== productEmpi);
                  }

                  // Actualizar el estado del botón original (no el temporal)
                  const originalButton = document.querySelector(`[data-empi="${productEmpi}"].wishlist-with-size`);
                  if (originalButton) {
                    originalButton.innerHTML =
                      window.WishlistSVGs?.ADD ||
                      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.35683 5.35683C6.16595 3.54772 9.0991 3.54772 10.9082 5.35683L12.0001 6.44873L13.092 5.35683C14.901 3.54823 17.8344 3.54815 19.6434 5.35683C21.4523 7.16581 21.4521 10.0991 19.6434 11.9082L12.0001 19.5515L4.35683 11.9082C2.54772 10.0991 2.54772 7.16595 4.35683 5.35683Z" stroke="#494B4D" stroke-linecap="round"/>
                      </svg>`;
                    originalButton.classList.remove('is-in-wishlist');
                    originalButton.classList.add('add-to-wishlist');
                    originalButton.dataset.inWishlist = 'false';

                    // Restaurar la funcionalidad original de añadir
                    originalButton.onclick = null; // Limpiar listeners anteriores
                    originalButton.addEventListener('click', function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      window.addToFavorites(this);
                    });

                    // ✅ Mostrar toast solo si realmente se eliminaron productos
                    if (Array.isArray(success) && success.length > 0) {
                      webvista.popToast(window.cardProductStrings.removedFromWishlist, 'success');

                      // 👇 REFRESCAR WISHLIST ASÍNCRONAMENTE DESPUÉS DE ELIMINAR
                      if (typeof window.refreshWishlistAsync === 'function') {
                        window.refreshWishlistAsync(function () {});
                      }
                    }
                  } else {
                  }
                },
                function (error) {
                  console.error('❌ Error eliminando todas las variantes:', error);
                  webvista.popToast(window.cardProductStrings.couldNotRemoveProduct, 'error');
                }
              );
            } else {
              console.error('❌ Swym no está disponible');
              webvista.popToast(window.cardProductStrings.couldNotRemoveProduct, 'error');
            }
          } else {
            // Fallback al comportamiento original
            originalRemoveFromWishlist(button);
          }
        } else {
          // Fallback al comportamiento original
          originalRemoveFromWishlist(button);
        }
      };

      // Ejecutar removeFromWishlist directamente
      window.removeFromWishlist(tempButton);

      // Restaurar la función original después de usarla
      window.removeFromWishlist = originalRemoveFromWishlist;
    } else {
      const { productUrl, epi, empi, du, dt, iu } = button.dataset;

      // Validar datos necesarios
      if (!epi || !empi || !du) {
        console.error('❌ Datos insuficientes para añadir a favoritos:', {
          epi,
          empi,
          du,
        });
        webvista.popToast(window.cardProductStrings.incompleteProductData, 'error');
        return;
      }

      // Guardar referencia del botón para actualizarlo después
      window.__swymWishlistTempData = {
        productUrl,
        epi,
        empi,
        du,
        dt,
        iu,
        swat: window._swat,
        lastClickedButton: button,
        isAdding: true,
        isRemoving: false,
      };

      // 👇 VERIFICAR SI HAY TALLA SELECCIONADA EN PDP
      const selectedVariant = button.dataset.selectedVariant;
      const selectedSize = button.dataset.selectedSize;
      const isSizeSelected = button.dataset.isSizeSelected === 'true';

      // Añadir a favoritos usando Swym con la primera variante
      if (typeof window._swat !== 'undefined' && window._swat.api) {
        // 👇 USAR SIEMPRE EL VARIANT ID ORIGINAL DEL PRODUCTO PARA SWYM
        // Swym puede no reconocer variants específicos, por lo que usamos el original
        const variantToUse = parseInt(epi);

        const productData = {
          epi: variantToUse,
          empi: parseInt(empi),
          du: du,
          dt: dt,
          iu: iu,
        };

        window._swat.api.addToWishList(
          productData,
          (res) => {
            // Mostrar confirmación según estado de sesión
            const message = window.isLoggedIn
              ? window.WISHLIST_I18N?.added_to_wishlist || window.cardProductStrings.addedToWishlist
              : window.WISHLIST_I18N?.added_to_wishlist_without_logging ||
                window.cardProductStrings.addedToWishlistWithoutLogging;
            webvista.popToast(message, 'success');

            // Actualizar el botón
            if (window.__swymWishlistTempData && window.__swymWishlistTempData.lastClickedButton) {
              const btn = window.__swymWishlistTempData.lastClickedButton;

              // Cambiar texto y clases
              btn.innerHTML =
                window.WishlistSVGs?.REMOVE ||
                `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.35683 5.35683C6.16595 3.54772 9.0991 3.54772 10.9082 5.35683L12.0001 6.44873L13.092 5.35683C14.901 3.54823 17.8344 3.54815 19.6434 5.35683C21.4523 7.16581 21.4521 10.0991 19.6434 11.9082L12.0001 19.5515L4.35683 11.9082C2.54772 10.0991 2.54772 7.16595 4.35683 5.35683Z" fill="#18191A" stroke="#18191A" stroke-linecap="round"/>
                </svg>`;
              btn.classList.add('is-in-wishlist');
              btn.classList.remove('add-to-wishlist');
              btn.dataset.inWishlist = 'true';

              // Actualizar variables globales
              if (window.wishlistProductIds) {
                window.wishlistProductIds.add(empi);
              }
            }

            // Forzar actualización de wishlist después de añadir desde PLP
            if (typeof window.forceWishlistRefresh === 'function') {
              window.forceWishlistRefresh(empi);
            } else if (typeof window.refreshWishlistAsync === 'function') {
              window.refreshWishlistAsync(function () {});
            }

            // Limpiar datos temporales
            window.__swymWishlistTempData = null;
          },
          (error) => {
            console.error('❌ Error al añadir a favoritos:', error);
            webvista.popToast(window.cardProductStrings.errorAddingToWishlist, 'error');
            window.__swymWishlistTempData = null;
          }
        );
      } else {
        console.error('❌ Swym API no disponible');
        webvista.popToast(window.cardProductStrings.errorAddingToWishlist, 'error');
        window.__swymWishlistTempData = null;
      }
    }
  };

  // Solo añadir el callback una vez
  if (!window.wishlistCallbackAdded) {
    window.wishlistCallbackAdded = true;
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      // Función para inicializar la wishlist
      function initializeWishlist() {
        if (window.wishlistInitialized) {
          return;
        }

        swat.fetchLists({
          callbackFn: function (lists) {
            // Buscar wishlist por diferentes criterios
            let wishlist = lists.find((list) => list.et === 3); // et = 3 es wishlist
            if (!wishlist) {
              wishlist = lists.find((list) => list.type === 'wishlist');
            }
            if (!wishlist) {
              wishlist = lists.find((list) => list.name && list.name.toLowerCase().includes('wish'));
            }
            if (!wishlist) {
              wishlist = lists.find((list) => list.name && list.name.toLowerCase().includes('favorit'));
            }

            // Si no encontramos wishlist específica, usar la primera lista disponible
            if (!wishlist && lists.length > 0) {
              wishlist = lists[0];
            }

            if (!wishlist) {
              window.wishlistInitialized = true;
              return;
            }

            window.wishlistLid = wishlist.lid;

            // La lista ya tiene el contenido en listcontents
            if (wishlist.listcontents && Array.isArray(wishlist.listcontents)) {
              window.wishlistItems = wishlist.listcontents;
              window.wishlistProductIds = new Set(window.wishlistItems.map((item) => item.empi.toString()));

              updateWishlistButtons();
              window.wishlistInitialized = true;
            } else {
              window.wishlistInitialized = true;
            }
          },
        });
      }

      // Función para actualizar el estado de todos los botones de wishlist
      function updateWishlistButtons() {
        const buttons = document.querySelectorAll('.wishlist-with-size');

        buttons.forEach((button) => {
          updateWishlistButton(button);
        });
      }

      // Función para actualizar un botón específico
      function updateWishlistButton(button) {
        const empi = button.dataset.empi;
        const isInWishlist = window.wishlistProductIds.has(empi);

        // Usar la función global para actualizar todos los botones del producto
        if (window.updateWishlistButtonState) {
          window.updateWishlistButtonState(empi, isInWishlist);
        } else {
          // Fallback al comportamiento original si la función global no está disponible
          if (isInWishlist) {
            button.innerHTML =
              window.WishlistSVGs?.REMOVE ||
              `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.35683 5.35683C6.16595 3.54772 9.0991 3.54772 10.9082 5.35683L12.0001 6.44873L13.092 5.35683C14.901 3.54823 17.8344 3.54815 19.6434 5.35683C21.4523 7.16581 21.4521 10.0991 19.6434 11.9082L12.0001 19.5515L4.35683 11.9082C2.54772 10.0991 2.54772 7.16595 4.35683 5.35683Z" fill="#18191A" stroke="#18191A" stroke-linecap="round"/>
              </svg>`;
            button.classList.add('is-in-wishlist');
            button.classList.remove('add-to-wishlist');
            button.dataset.inWishlist = 'true';

            // Asegurar que el botón mantenga su funcionalidad de eliminar
            button.onclick = null; // Limpiar listeners anteriores
            button.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              window.addToFavorites(this);
            });
          } else {
            button.innerHTML =
              window.WishlistSVGs?.ADD ||
              `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.35683 5.35683C6.16595 3.54772 9.0991 3.54772 10.9082 5.35683L12.0001 6.44873L13.092 5.35683C14.901 3.54823 17.8344 3.54815 19.6434 5.35683C21.4523 7.16581 21.4521 10.0991 19.6434 11.9082L12.0001 19.5515L4.35683 11.9082C2.54772 10.0991 2.54772 7.16595 4.35683 5.35683Z" stroke="#494B4D" stroke-linecap="round"/>
              </svg>`;
            button.classList.remove('is-in-wishlist');
            button.classList.add('add-to-wishlist');
            button.dataset.inWishlist = 'false';

            // Asegurar que el botón mantenga su funcionalidad original de añadir
            button.onclick = null; // Limpiar listeners anteriores
            button.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              window.addToFavorites(this);
            });
          }
        }
      }

      // Inicializar wishlist con un pequeño delay para asegurar que Swym esté completamente listo
      setTimeout(() => {
        if (!window.wishlistInitialized) {
          initializeWishlist();
        } else {
          updateWishlistButtons();
        }
      }, 100);
    });
  } else {
  }
})();
